import React, { useContext, useState } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";

function ContactsSection() {
  const { t } = useContext(LanguageContext);
  const [contacts, setContacts] = useState([]);
  const [showAddContacts, setShowAddContacts] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newContact, setNewContact] = useState({
    name: "",
    email: "",
    role: "",
  });

  const handleAddContactClick = () => {
    setShowAddContacts(!showAddContacts);
    setEditIndex(null);
    setNewContact({ name: "", email: "", role: "" });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewContact((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditClick = (index) => {
    setShowAddContacts(false);
    setEditIndex(index);
    setNewContact({ ...contacts[index] });
  };

  const handleSave = () => {
    if (editIndex !== null) {
      // Update an existing contact
      setContacts((prev) =>
        prev.map((contact, index) =>
          index === editIndex ? { ...newContact } : contact
        )
      );
    } else {
      // Add a new contact
      setContacts((prev) => [...prev, newContact]);
    }
    setEditIndex(null);
    setShowAddContacts(false);
    setNewContact({ name: "", email: "", role: "" });
  };

  const CancelEdit = () => {
    setEditIndex(null);
    setShowAddContacts(false);
    setNewContact({ name: "", email: "", role: "" });
  };

  return (
    <div id="contactsSection" className={`card ${showAddContacts ? "pb-2" : "pb-3"} card-setting`}>
      <div className="card-header">
        <h4 className="card-title">{t("Contacts")}</h4>
      </div>

      <div className="table-responsive">
        <table className="table table-thead-bordered table-nowrap table-align-middle card-table">
          <thead className="thead-light">
            <tr>
              <th>{t("NAME")}</th>
              <th>{t("EMAIL")}</th>
              <th>{t("ROLE")}</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {contacts.map((contact, index) => (
              <tr key={index}>
                <td className="ps-4">
                  {editIndex === index ? (
                    <input
                      className="form-control form-control-sm"
                      name="name"
                      value={newContact.name}
                      onChange={handleInputChange}
                    />
                  ) : (
                    contact.name
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <input
                      className="form-control form-control-sm"
                      name="email"
                      value={newContact.email}
                      onChange={handleInputChange}
                    />
                  ) : (
                    contact.email
                  )}
                </td>
                <td>
                  {editIndex === index ? (
                    <input
                      className="form-control form-control-sm"
                      name="role"
                      value={newContact.role}
                      onChange={handleInputChange}
                    />
                  ) : (
                    contact.role
                  )}
                </td>
                <td className="px-0">
                  <div className="dropdowm">
                    <button
                      type="button"
                      className="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                      id="teamsDropdown2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi-three-dots-vertical"></i>
                    </button>

                    <div
                      className="dropdown-menu dropdown-menu-sm dropdown-menu-end"
                      aria-labelledby="teamsDropdown2"
                    >
                      <button
                        className="dropdown-item"
                        onClick={() => handleEditClick(index)}
                      >
                        <i className="bi-pencil-fill dropdown-item-icon"></i>
                        {t("Edit")}
                      </button>
                      <div className="dropdown-divider"></div>
                      <button
                        className="dropdown-item text-danger"
                        onClick={() => {}}
                      >
                        <i className="bi-x-circle dropdown-item-icon"></i>{" "}
                        {t("Delete")}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
            {showAddContacts && (
              <tr>
                <td className="ps-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name"
                    value={newContact.name}
                    onChange={handleInputChange}
                    placeholder={t("Enter name")}
                  />
                </td>
                <td className="ps-2">
                  <input
                    type="email"
                    name="email"
                    className="form-control form-control-sm"
                    value={newContact.email}
                    onChange={handleInputChange}
                    placeholder={t("Enter email")}
                  />
                </td>
                <td className="ps-2">
                  <input
                    type="text"
                    name="role"
                    className="form-control form-control-sm"
                    value={newContact.role}
                    onChange={handleInputChange}
                    placeholder={t("Enter role")}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {!showAddContacts &&
        <div
          className={`${
            !showAddContacts && editIndex === null ? "mb-2 " : ''
          } ${
            !contacts.length ? "mt-3 " : ''
          }mb-1 px-3 text-primary`}
          onClick={handleAddContactClick}
          style={{ cursor: "pointer" }}
        >
          + {t("Add Contacts")}
        </div>
      }
      {(editIndex !== null || showAddContacts !== false) && (
        <>
          <hr style={{ width: "100%", margin: "4px 0px" }} />
          <div className="d-flex justify-content-end gap-3 px-4 py-3">
            <button
              className="btn btn-outline-primary"
              onClick={CancelEdit}
              style={{ padding: "0.38rem 1.83rem" }}
            >
              {t("Cancel")}
            </button>

            <button
              className="btn btn-primary"
              onClick={handleSave}
              style={{ padding: "0.38rem 2.23rem" }}
            >
              {t("Save")}
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default ContactsSection;
